import { LegalLayout } from "@/components/LegalLayout";
import { Link } from "react-router-dom";

export default function Contatti() {
  return (
    <LegalLayout title="Contatti">
      <p>
        Il Museo delle Promesse è un'opera digitale collettiva. Per qualsiasi richiesta, dubbio o comunicazione
        puoi scriverci.
      </p>
      <p>
        Per segnalare una promessa che ritieni non conforme, utilizza la pagina dedicata:
      </p>
      <p>
        <Link to="/segnala" data-testid="contatti-segnala-link" className="text-museo-accent uppercase text-sm tracking-[0.15em] hover:text-museo-text transition-colors">
          Segnala una promessa
        </Link>
      </p>
    </LegalLayout>
  );
}
